import React from 'react';
import { ReactSVG } from 'react-svg';

export default ({ className, src, onClick }) => (
  <ReactSVG
    className={className}
    src={require(`../assets/${src}.svg`)}
    onClick={onClick}
  />
);
